// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"cafad27e","143":"d89daed1","329":"55c64098","402":"7e5449f7","434":"3991e064","480":"a5d42bd9","535":"f3fe3975","709":"c99f9f55","807":"2cef1757"}[chunkId] + ".chunk.js";
};